import { render, staticRenderFns } from "./PendingTokenBanner.vue?vue&type=template&id=2c25af59&scoped=true"
import script from "./PendingTokenBanner.vue?vue&type=script&lang=js"
export * from "./PendingTokenBanner.vue?vue&type=script&lang=js"
import style0 from "./PendingTokenBanner.vue?vue&type=style&index=0&id=2c25af59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c25af59",
  null
  
)

export default component.exports